import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { SkusActions } from 'state/modules/skus';
import { useDispatch, useSelector } from 'react-redux';
import SkuAccounting from 'components/Skus/SkusWizard/Accounting';
import { generateTaxTypes } from 'constants';
import { ability } from '../../../Can';

const UpdateAccountingModal = ({ id, open, handleClick }) => {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const {
    sku,
    fetchingUpdateSku,
    onboarding: { errors },
  } = useSelector((state) => state.skus);
  const TRSEnabled = useSelector(
    (state) => state.config.settings?.core?.pricing?.tax_rules_set?.enabled || false
  );
  const allowTaxPerLocation = TRSEnabled && ability.can('read', 'tax_rules_set');
  const taxTypes = generateTaxTypes(allowTaxPerLocation ? [] : ['PERLOCATION']);

  useEffect(() => {
    if (id) {
      dispatch(SkusActions.fetchSkuById(id));
    }
  }, [id]); // eslint-disable-line

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  const getAccountingData = () => {
    const taxing_choice = taxTypes.find(
      (tt) =>
        tt?.value === sku?.taxing_choice ||
        tt?.label?.toLowerCase() === sku?.taxing_choice?.toLowerCase()
    );

    const data = {
      accounting_type: sku?.accounting_type?._type,
      taxing_choice: taxing_choice ? taxing_choice?.value : sku?.taxing_choice || '',
      accounting_type_id: sku?.accounting_type?.id || '',
      tax_rate_default: typeof sku?.tax_rate_default == 'number' ? sku?.tax_rate_default : '',
      tax_rules_set: sku?.tax_rules_set || '',
    };
    return data;
  };

  return (
    <BaseModal
      size="md"
      open={open}
      hasEnterButton
      hasCancelButton
      onEnter={onSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      enterButtonLabel={i18n.t('common.save')}
      loading={fetchingUpdateSku}
      title={i18n.t('skus.edit_accounting_info')}
    >
      <SkuAccounting
        id={id}
        center={false}
        errors={errors}
        formRef={formRef}
        onSave={handleClick}
        step={getAccountingData()}
      />
    </BaseModal>
  );
};

UpdateAccountingModal.propTypes = {
  id: PropTypes.any,
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

UpdateAccountingModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default UpdateAccountingModal;
